import { render, staticRenderFns } from "./WaitingRoom.vue?vue&type=template&id=2445beef&scoped=true&"
import script from "./WaitingRoom.vue?vue&type=script&lang=js&"
export * from "./WaitingRoom.vue?vue&type=script&lang=js&"
import style0 from "./WaitingRoom.vue?vue&type=style&index=0&id=2445beef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445beef",
  null
  
)

export default component.exports